import { createRef } from 'react';
import { NavigationContainerRef, StackActions } from '@react-navigation/native';

// Define our app's routes
export type RootStackParamList = {
  Home: { opportunityId?: string } | undefined;
  Opportunity: { opportunityId: string };
  About: undefined;
  Contact: undefined;
  Team: undefined;
  Login: undefined;
  SignUp: undefined;
  PrivacyPolicy: undefined;
  Letter: undefined;
  OrganizationDashboard: undefined;
  SchoolAdminDashboard: undefined;
  TeacherPortal: undefined;
  StudentPortal: { schoolSlug: string }; // Route: /:schoolSlug (e.g., /seaquam)
};

// Create a navigation ref that can be used outside of React components
export const navigationRef = createRef<NavigationContainerRef<RootStackParamList>>();

// Navigation functions that can be used anywhere
export function navigate(name: keyof RootStackParamList, params?: any) {
  if (navigationRef.current) {
    // Type assertion needed due to complexity of React Navigation types
    navigationRef.current.navigate(name as any, params);
  }
}

export function reset(routes: { name: keyof RootStackParamList, params?: any }[], index: number = 0) {
  if (navigationRef.current) {
    navigationRef.current.reset({
      index,
      routes: routes.map(route => ({ name: route.name as any, params: route.params }))
    });
  }
}

export function push(name: keyof RootStackParamList, params?: any) {
  if (navigationRef.current) {
    navigationRef.current.dispatch(StackActions.push(name as any, params));
  }
}

export function goBack() {
  if (navigationRef.current && navigationRef.current.canGoBack()) {
    navigationRef.current.goBack();
  }
}

export function getCurrentRoute() {
  if (navigationRef.current) {
    return navigationRef.current.getCurrentRoute()?.name;
  }
  return undefined;
} 